import { ZepIcon_default } from './chunk-SGEFWXJL.mjs';
import { jsxs, jsx } from 'react/jsx-runtime';

var GraduationcapFillIcon = ZepIcon_default(
  (props) => /* @__PURE__ */ jsxs("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", ...props, children: [
    /* @__PURE__ */ jsx(
      "path",
      {
        d: "M11.617 4.16a1 1 0 0 1 .769 0l9.516 3.965c.595.248.708.972.35 1.405v4.27a.75.75 0 0 1-1.5 0v-3.582l-8.4 3.15a1 1 0 0 1-.702 0l-9.52-3.57c-.763-.286-.782-1.36-.03-1.673l9.517-3.965ZM21.503 15a.96.96 0 0 0-.932.728l-.257 1.03a1 1 0 0 0 .97 1.242h.438a1 1 0 0 0 .97-1.242l-.257-1.03a.96.96 0 0 0-.932-.728Z",
        fill: props.fill || "currentColor"
      }
    ),
    /* @__PURE__ */ jsx(
      "path",
      {
        d: "m11.65 14.368-6.648-2.493v4.128c0 .263.046.523.131.771C5.764 18.613 8.6 20 12.002 20c3.402 0 6.238-1.387 6.869-3.226.085-.248.131-.508.131-.77v-4.129l-6.649 2.493a1 1 0 0 1-.702 0Z",
        fill: props.fill || "currentColor"
      }
    )
  ] })
);

export { GraduationcapFillIcon };
